import { render } from "./DpiDeliveredView.vue?vue&type=template&id=9927e666&ts=true"
import script from "./DpiDeliveredView.vue?vue&type=script&lang=ts"
export * from "./DpiDeliveredView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__